<app-header></app-header>
<div #myDIV class="wrapper" infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="150"
  (scrolled)="onScroll()" [infiniteScrollDisabled]="category">
  <app-banner-simmer *ngIf="isLoding === true"></app-banner-simmer>
  <app-banner-slider *ngIf="featuredData?.featured?.length > 0" [data]="featuredData" [slug]="type"></app-banner-slider>
  <section *ngIf="watchingData && service.listStatus" class="text-center pt-3">
    <app-continue-watching [content]="'continueWatchingData'"></app-continue-watching>
  </section>
  <!-- <div *ngIf="service.listStatus && service.popularSeries">
    <hr class="pb-4 my-0" />
  </div> -->
  <!-- <section>
    <app-partner-content [content]="content[3]"></app-partner-content>
  </section> -->
  <app-grid-list *ngIf="service.popularSeries"></app-grid-list>
  <!-- <app-popular-content
    *ngIf="!service.contentPopular"
    [content]="content[1]"
    (mouseenter)="playOff()"
  ></app-popular-content> -->
  <app-rectangle-simmer *ngIf="category === true"></app-rectangle-simmer>
  <div class="home-page multi-slider-section" *ngIf="!category || (!loadMore && subcategory?.length > 0)">
    <div>
      <section class="multi-slider">
        <div *ngFor="let category of subcategory; let c = index">
          <div class="multi-loop" *ngIf="category?.content?.length > 0">
            <div class=" container">
              <div class="section-head" (mouseenter)="playOff()">
                <div class="d-flex align-items-center flex-wrap">
                  <a class="mr-2" [routerLink]="
                      category.subcategoryCount > 0
                        ? ['/category', category.slug]
                        : ['/list', category.slug]
                    ">
                    <h2>{{ category | languageTranslate }}</h2>
                  </a>
                  <span class="head-batch" *ngIf="category.sub_title">{{
                    category.sub_title
                    }}</span>
                </div>
                <a *ngIf="category.content.length > 5" href="javascript:void(0)" class="text-primary view-all-link"
                  [routerLink]="
                    category.subcategoryCount > 0
                      ? ['/category', category.slug]
                      : ['/list', category.slug]
                  ">
                  {{ "HOME.VIEW_ALL" | translate }}
                </a>
              </div>

              <div class="populer-slider" id="slider-top">
                <owl-carousel-o [options]="watching">
                  <ng-container *ngFor="let watch of category.content; let i = index">
                    <ng-template carouselSlide [id]="watch.public_id">
                      <div class="series-box">
                        <app-grid [data]="watch" [gridType]="'portrait'" [type]="'home'"></app-grid>
                      </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- <div class="text-center" *ngIf="show === true" (mouseenter)="playOff()">
        <button
          type="button"
          class="btn btn-theme"
          (click)="viewMoreData()"
        >
          View More
        </button>
      </div> -->
      <app-rectangle-simmer *ngIf="loadMore"></app-rectangle-simmer>
    </div>
  </div>
  <!-- <div *ngIf="subcategory.length > 0">
    <hr class="pb-4 my-0" />
  </div> -->

  <!-- <div
    class="record-not-available"
    *ngIf="subcategory?.length === 0 && !category"
  >
    <div class="text-center">
      <img src="assets/images/no-recoard-playlist.png" />
      <p class="no-recored-content text-secondary">
        {{ "RECORD_NOT_FOUND" | translate }}
      </p>
    </div>
  </div> -->
  <app-grid-slider-list *ngIf="service.contentPopular" [content]="content[0]" (mouseenter)="playOff()">
  </app-grid-slider-list>
  <!-- <section class="about-video-sect">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 col-md-6">
          <div class="ratio-16-9">
            <img src="https://d1tcjcrle6fjgd.cloudfront.net/thumbnails/1615978569750.jpg" />
            <a href="javascript:void()" class="play-btn btn-theme">
              <span class="icon-play"></span>
            </a>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="about-content">
            <span class="sub-title">trailer</span>
            <h5 class="title text-white">Password</h5>
            <p class="text-secondary fw-bold">
              When a body mase up of 2 diffrent people is found between Malaysia
              and Singapore, two detectives must team up to solve the mystery.
            </p>
            <span class="text-secondary fw-bold">By</span>
            <p class="mb-0 text-white">
              Bront Palarae, Erwin Dawson, Izzat Mushtaq, Charies Roberts
            </p>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <app-genre-slider (mouseenter)="playOff()"></app-genre-slider>
  <!-- <app-language-grid></app-language-grid> -->
  <app-grid-slider-list [content]="content[2]" (mouseenter)="playOff()"></app-grid-slider-list>
</div>
<app-model-player *ngIf="service.modelData" [data]="service.modelData" [playerStatus]="service.playerReady"
  [position]="service.position"></app-model-player>
<app-footer></app-footer>